var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattlefield6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4676_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5119 10.0417V8.2274C8.5119 5.92074 6.11582 6.08167 5.60093 6.08167H2V17.9976H5.60093C6.11582 17.9976 8.5119 18.158 8.5119 15.8507V14.0364C8.5119 12.5153 7.77784 12.1451 7.54439 12.0391C7.77784 11.933 8.5119 11.5628 8.5119 10.0417ZM4.10492 7.83938H5.55749C6.25524 7.83938 6.39855 8.0617 6.39855 8.49979V10.4923C6.39855 10.9048 6.14305 11.1605 5.56592 11.1605H4.10492V7.83938ZM6.39855 15.5789C6.39855 16.017 6.25524 16.2393 5.55749 16.2393H4.10492V12.9182H5.56592C6.14305 12.9182 6.39855 13.1739 6.39855 13.5864V15.5789Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6924 6.07867V7.83639H11.4131V11.1599H14.4979V12.9176H11.4131V17.9994H9.30823V6.07867H14.6924Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0897 10.6086H18.226L20.3458 6H18.0554L15.6503 11.2618C15.5355 11.53 15.4882 11.7225 15.4882 12.0069V15.7702C15.4882 18.0787 17.8849 17.9189 18.3978 17.9189H19.0904C19.6033 17.9189 22.0001 18.0787 22.0001 15.7702V12.7549C22.0001 10.4494 19.6033 10.6091 19.0904 10.6091H19.0897V10.6086ZM19.8861 16.16H17.6015V12.3669H19.8861V16.16Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4676_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 12,
    fill: "white",
    transform: "translate(2 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattlefield6);
export default __webpack_public_path__ + "static/media/battlefield6.60d989c15e6287b970ea80d9278dd176.svg";
export { ForwardRef as ReactComponent };